import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Html5QrcodeScanner, Html5QrcodeScanType } from "html5-qrcode";
import { Button } from "primereact/button";

/* eslint-disable-next-line */
export interface ScanProps {
  isCloseOnScan?: boolean;
  successScan?: (result: string) => void;
  closeScan?: () => void;
}

export function Scan({ isCloseOnScan, successScan, closeScan }: ScanProps) {
  let html5QrcodeScanner: any;

  const [scanResult, setScanResult] = useState("");

  useEffect(() => {
    if (!html5QrcodeScanner?.getState()) {
      html5QrcodeScanner = new Html5QrcodeScanner(
        "reader",
        {
          fps: 10,
          qrbox: { width: 550, height: 550 },
          supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
        },
        false
      );
      html5QrcodeScanner.render(success, undefined);
    }

    function success(result: any) {
      html5QrcodeScanner.clear();
      setScanResult(result);
      if (successScan) {
        successScan(result);
      }

      if (isCloseOnScan) {
        handleReturn();
      }
    }
  }, []);

  const handleReturn = () => {
    if (html5QrcodeScanner) {
      html5QrcodeScanner
        .clear()
        .then((x: any) => {})
        .catch((error: any) => {
          console.error("Failed to clear html5QrcodeScanner. ", error);
        });
    }

    if (closeScan) {
      closeScan();
    }
  };

  return (
    <div id="Scan">
      {scanResult ? (
        <section className="flex flex-col justify-center items-center">
          <h1>Scanning Complete</h1>
        </section>
      ) : (
        <div id="reader"></div>
      )}
      <div className="flex w-full justify-center">
        <Button
          className="mt-4"
          severity="secondary"
          label="Close"
          onClick={() => handleReturn()}
          outlined
        />
      </div>
    </div>
  );
}

export default Scan;
